import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import storeReducer from './stores/storeSlice';
import customerReducer from './customer/customerSlice';
import analyticReducer from './analytics/analyticsSlice';
import bannerReducer from './advertisement/bannerSlice';
import adminReducer from './user/userSlice';
import productServiceReducer from './product-service/productServiceSlice';
import categoryReducer from './category/categorySlice';
import prelistProductServiceReducer from './prelist-product-service/prelistProductServiceSlice';
import reportReducer from './report/reportSlice';
import vehicleReducer from './vehicle/vehicleSlice';
import ratingReducer from './rating-and-reviews/RatingAndReviewsSlice';
import eventReducer from './event/eventSlice';
import offerReducer from './offer/offerSlice';
import offerReportReducer from './offer-report/offerReportSlice';
import businessReducer from './business/businessSlice';
import schoolAutoReducer from './school-auto/schoolAutoSlice';
import partnerProductReducer from './partner-product/partnerProductSlice';
import newVehicleReducer from './new-vehicle/newVehicleSlice';
import spEmployeeReducer from './spEmployee/spEmployeeSlice';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const rootReducer = combineReducers({
  storeReducer,
  customerReducer,
  analyticReducer,
  bannerReducer,
  businessReducer,
  adminReducer,
  productServiceReducer,
  categoryReducer,
  prelistProductServiceReducer,
  reportReducer,
  vehicleReducer,
  ratingReducer,
  eventReducer,
  offerReducer,
  offerReportReducer,
  schoolAutoReducer,
  partnerProductReducer,
  newVehicleReducer,
  spEmployeeReducer
});

export { rootPersistConfig, rootReducer };
